import React, { useContext, useRef, useEffect, useState, Fragment } from 'react'
import { Helmet } from 'react-helmet-async'

import { useForm, useWatch, useFieldArray } from 'react-hook-form'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup";
import { getFunctions, httpsCallable } from "firebase/functions";

import Button from '@/components/Button'
import Tabs from '@/components/Tabs'
import Loader from '@/components/Loader'
import { StakeContext } from '@/contexts/StakeContext'
import { ChevronDownIcon, MenuAlt2Icon } from '@heroicons/react/solid'
import modalRoutes from '@/modalRoutes'
import { AuthContext } from '../../contexts/AuthContext'
import Popover from '@/components/Popover'
import Duel from '../../components/Duel'
import { useFirestore } from 'react-redux-firebase'
import Link from '@/components/Link'
import { format } from 'date-fns'
import { convertAmount } from '../../utils/currencyResolver';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/solid'
import { RadioGroup } from '@headlessui/react'
import { classNames } from '@/utils/classNames'
import errorToast from '@/utils/errorToast';
import { useBalance } from '@/hooks/useBalance'
import { ModalContext } from '@/contexts/ModalContext'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'

const filters = [
  { name: 'All', value: 0 },
  { name: '0 - 99M', value: 100 },
  { name: '100M - 499M', value: 500 },
  { name: '500M+', value: 1000 },
]

const weapons = [
  { image: '/weapons/12006.png', value: "12006" },
  { image: '/weapons/5698.png', value: "5698" },
  { image: null, value: "0", name: "Any" }
]

export default function Arena() {
  const [plan, setPlan] = useState(0)
  const { translatedStakes, isLoading } = useContext(StakeContext)
  const [selected, setSelected] = useState(filters[0])

  return (
    <>
      <Helmet>
        <title>Duel Arena</title>
      </Helmet>
      <div className="py-8">
        {isLoading ? <Loader /> : (
          <div className="container">
            <div className="md:flex justify-between items-center">
              <div className="flex justify-between items-center mb-4 md:mb-0">
                <h1 className="font-medium text-lg sm:text-xl text-white">Matchmaking</h1>
                {/* <div className="sm:hidden">
                  <Button rounded="rounded-full" modifier="secondary" link to={modalRoutes.CREATE_DUEL} className="px-4 py-2.5 whitespace-nowrap flex">Create a duel</Button>
                </div> */}
              </div>
              <div className="flex-col md:flex-row flex w-full mt-2 sm:mt-0 sm:w-auto">
                <div className="flex mt-4 md:mt-0 md:mr-2 order-last md:order-first w-48">
                  <Listbox className="w-full z-50 relative flex" value={selected} onChange={setSelected}>
                    <div className="w-full relative mt-1">
                      <Listbox.Button className="relative items-center w-full py-2 flex justify-between bg-gray-900 border border-gray-300 border-opacity-20 rounded">
                        <div className="flex px-2">
                          <div className="text-gray-300 flex items-center space-x-2"><span className="text-gray-300 text-opacity-50">Filters:</span><span className="text-gray-200 font-medium flex items-center">{selected.name}</span></div>
                        </div>
                        <ChevronDownIcon className="text-gray-300 w-5 mr-1.5" />
                      </Listbox.Button>
                      <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Listbox.Options className="absolute w-full right-0 py-1 top-full mt-1 border border-gray-300 border-opacity-20 overflow-auto bg-gray-900 text-gray-300 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                          {filters.map((filter, filterIdx) => (
                            <Listbox.Option
                              key={filterIdx}
                              className={({ active }) =>
                                `${active ? '' : 'text-gray-200'}
                          cursor-pointer select-none relative p-2 flex items-center whitespace-nowrap hover:bg-gray-800`
                              }
                              value={filter}
                            >
                              {({ selected, active }) => (
                                <>
                                  <img src="/icons/GP_COIN_03.svg" alt="" className="w-7 mr-1" />
                                  <span
                                    className={`${selected ? 'font-medium' : 'font-normal'
                                      }`}
                                  >
                                    {filter.name}
                                  </span>
                                </>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </Listbox>
                </div>
                <QuickStart />
                {/* <div className="flex-1">
                  <RadioGroup className="flex flex-wrap space-x-2" value={plan} onChange={setPlan}>
                    <RadioGroup.Option value={0}>
                      {({ checked }) => (
                        <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>All</span>
                      )}
                    </RadioGroup.Option>
                    <RadioGroup.Option value={100}>
                      {({ checked }) => (
                        <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>0 - 99M</span>
                      )}
                    </RadioGroup.Option>
                    <RadioGroup.Option value={500}>
                      {({ checked }) => (
                        <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>100M - 499M</span>
                      )}
                    </RadioGroup.Option>
                    <RadioGroup.Option value={1000}>
                      {({ checked }) => (
                        <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>500M+</span>
                      )}
                    </RadioGroup.Option>
                  </RadioGroup>
                </div> */}
                {/* <div className="hidden sm:block">
                  <Button rounded="rounded-full" modifier="secondary" link to={modalRoutes.CREATE_DUEL} className="px-4 py-2.5 whitespace-nowrap flex">Create a duel</Button>
                </div> */}
              </div>
            </div>
            {translatedStakes?.filter(stake => !stake?.rematchOffered?.accepted).filter(stake => stake && stake.expiryTime ? new Date() < (new Date(stake.expiryTime).getTime() + 10000) : stake).length > 0 ? <ActiveDuels filters={selected.value} stakes={translatedStakes} /> : <NoActiveDuels />}
          </div>
        )}
      </div>
      <div className="container py-8">
        <StakeHistoryTable />
      </div>
    </>
  )
}

const QuickStart = () => {
  const functions = getFunctions();
  const createDuel = httpsCallable(functions, 'createDuel');
  const { auth, userBalance, userAccounts, userPrimaryAccount } = useContext(AuthContext);
  const [weapon, setWeapon] = useState(weapons[0])

  const schema = yup.object().shape({
    amount: yup.number().required().positive().min(0).max(userBalance),
  });

  const { register, handleSubmit, control, setValue, formState: { errors, isSubmitting }, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      amount: 0,
    }
  });

  const amount = useWatch({
    control,
    name: "amount",
    defaultValue: 0
  });

  useEffect(() => {
    if (Object.entries(errors).length > 0) {
      if (errors?.amount) {
        errorToast({ message: 'Insufficient funds.' })
      }
    }
  }, [errors])

  const { displayValue, value } = useBalance(amount)

  const onSubmitHandler = async (data) => {
    if (userAccounts.length == 0) {
      errorToast({ message: 'Please link an account before creating a duel.' })
      return null
    }
    if (!userPrimaryAccount) {
      errorToast({ message: 'Please set a linked account to primary before creating a duel.' })
      return null
    }
    try {
      await createDuel({
        allowedWeapons: weapon.value == "5968" ? ["12006", "5968"] : [weapon.value],
        wager: Number(data.amount)
      })
    } catch (err) {
      errorToast(err)
    }
  }

  const handleChange = e => {
    setValue('amount', e.target.value * 1000000)
  }

  return (
    <form className="sm:flex sm:space-x-2" onSubmit={handleSubmit(onSubmitHandler)}>
      <div className={classNames('relative bg-gray-900 border border-gray-300 border-opacity-20 rounded flex', errors?.amount ? '!border-red-500 border-opacity-100' : '')}>
        <img src="/icons/GP_COIN_03.svg" alt="" className="w-7 ml-1" />
        <input {...register('amount')} type="hidden" required className={errors?.amount ? '!border-red-500 absolute' : 'absolute'} />
        <input type="number" step=".01" value={displayValue == 0 ? '' : displayValue} placeholder="Amount..." onChange={handleChange} required className="text-gray-200 p-0 pl-1 placeholder-gray-300 hover:placeholder-gray-200 bg-transparent border-none" />
        <div className="p-1">
          <div className="px-3 py-2 sm:py-0 bg-gray-800 h-full rounded shadow font-medium text-gray-300 text-sm flex items-center justify-center">M</div>
        </div>
        <div className="border-l border-r flex space-x-1 border-gray-300 border-opacity-20 p-1">
          <button onClick={() => setValue('amount', 0)} type="button" className="px-3 bg-gray-800 text-gray-300 hover:text-gray-200 h-full rounded shadow font-medium text-xs whitespace-nowrap flex items-center justify-center">
            <span>Clear</span>
          </button>
          <button onClick={() => setValue('amount', userBalance)} type="button" className="px-3 bg-gray-800 text-gray-300 hover:text-gray-200 h-full rounded shadow font-medium text-xs whitespace-nowrap flex items-center justify-center">
            <span>Use Max</span>
          </button>
        </div>
        <div className="border-l border-r flex space-x-1 border-gray-300 border-opacity-20">
          {/* <button onClick={() => setValue('amount', 0)} type="button" className="px-3 bg-gray-800 text-gray-300 hover:text-gray-200 h-full rounded shadow font-medium text-xs whitespace-nowrap flex items-center justify-center">
            <span>Clear</span>
          </button> */}
          <Listbox className="w-full z-50 relative flex" value={weapon} onChange={setWeapon}>
            <div className="w-full relative mt-1">
              <Listbox.Button className="relative p-1 items-center w-full flex justify-between bg-gray-900">
                {weapon.image ? (
                  <div style={{ width: 32 }} className="flex flex-shrink-0">
                    <img style={{ width: 32 }} src={weapon.image} alt="" />
                  </div>
                ) : (
                  <p className="text-xs text-gray-300 px-1 font-medium">{weapon.name}</p>
                )}
                <ChevronDownIcon className="text-gray-300 flex-shrink-0 w-4 ml-1.5" />
              </Listbox.Button>
              <Transition
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options className="absolute w-full right-0 py-1 top-full mt-1 border border-gray-300 border-opacity-20 overflow-auto bg-gray-900 text-gray-300 rounded shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {weapons.filter(weapon => weapon.image).map((weapon, weaponIdx) => (
                    <Listbox.Option
                      key={weaponIdx}
                      className={({ active }) =>
                        `${active ? '' : 'text-gray-200'}
                          cursor-pointer select-none relative flex items-center whitespace-nowrap hover:bg-gray-800 border-b border-gray-800 p-1`
                      }
                      value={weapon}
                    >
                      {({ selected, active }) => (
                        <>
                          <img style={{ width: 32 }} className="mx-auto" src={weapon.image} alt="" />
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                  {weapons.filter(weapon => !weapon.image).map((weapon, weaponIdx) => (
                    <Listbox.Option
                      key={weaponIdx}
                      className={({ active }) =>
                        `${active ? '' : 'text-gray-200'}
                          cursor-pointer select-none relative flex items-center whitespace-nowrap hover:bg-gray-800 border-b border-gray-800 last:border-0 p-1`
                      }
                      value={weapon}
                    >
                      {({ selected, active }) => (
                        <>
                          <span className="py-2 text-center mx-auto">{weapon.name}</span>
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </div>
          </Listbox>
        </div>
      </div>
      <div className="border border-transparent">
        {auth?.uid ? (
          <Button modifier="secondary" type="submit" className="px-4 py-2.5 whitespace-nowrap flex w-full sm:w-auto mt-2 sm:mt-0">
            {isSubmitting ? (
              <span className="flex items-center justify-center">
                Creating
                <svg className="animate-spin ml-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
            ) : (
              <span>Create</span>
            )}
          </Button>
        ) : (
          <Button modifier="secondary" link to={modalRoutes.LOGIN} type="button" className="px-4 py-2.5 whitespace-nowrap flex w-full sm:w-auto mt-2 sm:mt-0">Create</Button>
        )}
      </div>
    </form>
  )
}

const ActiveDuels = ({ stakes, filters }) => {
  // const [filters, setFilters] = useState(0)
  const filteredStakes = {
    0: stakes?.filter(stake => stake),
    100: stakes?.filter(stake => stake?.wager >= 0 && stake?.wager < 99999999),
    500: stakes?.filter(stake => stake?.wager >= 100000000 && stake?.wager < 499999999),
    1000: stakes?.filter(stake => stake?.wager >= 500000000)
  }[filters]
  return (
    <div className="flex flex-col rounded-md py-4 mt-4">
      {/* <div className="flex justify-center sm:justify-end flex-1 mb-4">
        <RadioGroup className="flex flex-wrap space-x-2" value={filters} onChange={setFilters}>
          <RadioGroup.Option value={0}>
            {({ checked }) => (
              <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>All</span>
            )}
          </RadioGroup.Option>
          <RadioGroup.Option value={100}>
            {({ checked }) => (
              <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>0 - 99M</span>
            )}
          </RadioGroup.Option>
          <RadioGroup.Option value={500}>
            {({ checked }) => (
              <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>100M - 499M</span>
            )}
          </RadioGroup.Option>
          <RadioGroup.Option value={1000}>
            {({ checked }) => (
              <span className={classNames('whitespace-nowrap text-xs cursor-pointer bg-gray-900 border-2 relative rounded py-1 transition duration-300 px-3 flex items-center justify-center font-medium', checked ? 'opacity-100 text-white border-purple-600' : 'text-gray-300 border-transparent')}>500M+</span>
            )}
          </RadioGroup.Option>
        </RadioGroup>
      </div> */}
      {stakes && filteredStakes?.length > 0 ? (
        // <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 lg:dark:grid-cols-2 xl:grid-cols-3 gap-3">
          {filteredStakes?.map(stake => (
            <Duel key={stake?.id} stake={stake} />
          ))}
        </div>
      ) : (
        <div className="py-24 flex flex-col text-gray-300 items-center justify-center mx-auto w-full">
          <p className="text-center">No duels matching your filter criteria. Why don't you create one?</p>
          {/* <Button modifier="secondary" rounded="rounded-full" link to={modalRoutes.CREATE_DUEL} className="px-4 py-2.5 mt-4">Create a duel</Button> */}
        </div>
      )}
    </div >
  )
}

const NoActiveDuels = () => {
  return (
    <div className="py-24 flex flex-col items-center text-gray-300 justify-center">
      <p className="text-center">No duels at the moment. Why don't you create one?</p>
      {/* <Button modifier="secondary" rounded="rounded-full" link to={modalRoutes.CREATE_DUEL} className="px-4 py-2.5 mt-4">Create a duel</Button> */}
    </div>
  )
}

const StakeHistoryTable = () => {
  const firestore = useFirestore()
  const [duelsData, setDuelsData] = useState([])
  const { auth } = useContext(AuthContext)
  useEffect(() => {
    firestore.collection("duels").where("fightEnd", "!=", null).orderBy("fightEnd", "desc").onSnapshot((snapshot) => {
      let duelsArr = []
      snapshot.docs.forEach(doc => {
        duelsArr.push({ id: doc.id, ...doc.data() })
      })
      setDuelsData(duelsArr)
    })
  }, [])

  return (
    <Tabs
      items={[
        {
          title: 'All Duels',
          panel: <div className="overflow-x-auto">
            <table className="w-full text-gray-300">
              <thead className="mb-4">
                <tr>
                  <th className="w-24 p-4 text-sm font-medium text-left whitespace-nowrap">Time</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 1</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 2</th>
                  <th className="w-24 p-4 text-sm font-medium text-center whitespace-nowrap">Wager</th>
                  <th className="w-24 p-4 text-sm font-medium text-right whitespace-nowrap">Payout</th>
                </tr>
              </thead>
              <tbody>
                {duelsData?.slice(0, 8)?.map(item => <TableRow item={item} key={item.id} />)}
              </tbody>
            </table>
          </div>
        },
        {
          title: 'My Duels',
          panel: <div className="overflow-x-auto">
            <table className="w-full text-gray-300">
              <thead className="mb-4">
                <tr>
                  <th className="w-24 p-4 text-sm font-medium text-left whitespace-nowrap">Time</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 1</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 2</th>
                  <th className="w-24 p-4 text-sm font-medium text-center whitespace-nowrap">Wager</th>
                  <th className="w-24 p-4 text-sm font-medium text-right whitespace-nowrap">Payout</th>
                </tr>
              </thead>
              <tbody>
                {duelsData?.filter(duel => duel.created.id == auth?.uid || duel.joined.id == auth?.uid)?.slice(0, 8).map(item => <TableRow item={item} key={item.id} />)}
              </tbody>
            </table>
          </div>
        },
        {
          title: 'Highrollers',
          panel: <div className="overflow-x-auto">
            <table className="w-full text-gray-300">
              <thead className="mb-4">
                <tr>
                  <th className="w-24 p-4 text-sm font-medium text-left whitespace-nowrap">Time</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 1</th>
                  <th className="w-32 p-4 text-sm font-medium text-center whitespace-nowrap">Player 2</th>
                  <th className="w-24 p-4 text-sm font-medium text-center whitespace-nowrap">Wager</th>
                  <th className="w-24 p-4 text-sm font-medium text-right whitespace-nowrap">Payout</th>
                </tr>
              </thead>
              <tbody>
                {duelsData?.filter(duel => duel.wager >= 500000000)?.slice(0, 8).map(item => <TableRow item={item} key={item.id} />)}
              </tbody>
            </table>
          </div>
        },
      ]}
      routing={false}
      navWrapperClass="flex justify-start mb-4"
    />
  )
}


const TableRow = ({ item }) => {
  const getFormatted = () => {
    const data = format(new Date(item?.fightEnd?.seconds * 1000), 'K:mm aa')
    const isMidnight = "0:" == data.substring(0, 2)
    if (isMidnight) {
      return "12:" + data.slice(2)
    } else {
      return data
    }
  }
  return (
    <tr className="p-4 rounded odd:bg-gray-900 rounded">
      <td className="p-4 text-sm text-gray-200 rounded-l">{getFormatted()}</td>
      <td className="p-4 text-sm truncate">{translateUser(item, "created")}</td>
      <td className="p-4 text-sm truncate">{translateUser(item, "joined")}</td>
      <td className="p-4 text-sm">
        <div className="flex items-center justify-center text-gray-200">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(item.wager)}
        </div>
      </td>
      <td className="p-4 text-sm rounded-r">
        <div className="flex items-center justify-end text-gray-200">
          <img className="w-6" src="/icons/GP_COIN_03.svg" alt="" /> {convertAmount(item.payout)}
        </div>
      </td>
    </tr>
  )
}

const translateUser = (item, slot) => {
  const property = slot == "created" ? item.createdUsername : item.joinedUsername
  let winner

  if (item.winner.id == item.created.id) {
    winner = "created"
  } else {
    winner = "joined"
  }

  if (!property) return (
    <p className="flex items-center justify-center space-x-1">
      {winner === slot ? <CheckCircleIcon className="h-4 w-4 text-green-500 flex-shrink-0" /> : <XCircleIcon className="h-4 w-4 text-red-500 flex-shrink-0" />}
      <span className="font-medium">Hidden</span>
    </p>
  )
  return (
    <Link className="flex items-center justify-center space-x-1" to={{ search: '&modal=user&name=' + property }}>
      {winner === slot ? <CheckCircleIcon className="h-4 w-4 text-green-500 flex-shrink-0" /> : <XCircleIcon className="h-4 w-4 text-red-500 flex-shrink-0" />}
      <span className="text-gray-200 font-medium">{property}</span>
    </Link>
  )
}